import { DEFAULT_THEME } from "./defaultTheme";

export const THEMES = {
  default_theme: DEFAULT_THEME,
} as const;
